module.exports = __webpack_public_path__ + "assets/media/arrow-left-prize.3725a760.svg";